export const getStringWithoutMarkup = (inputString: string): string => {
  const regex = /(<([^>]+)>)/gi;
  return inputString.replace(regex, '');
};
